<template>
    <b-container fluid class="mt--7">
        <view-item
            v-if="!!item"
            :item="item"
            @success="alertSuccess"
            @delete-item="deleteType"
            @cancel="item = null"
            @error="showError"
        ></view-item>

        <list-items
            v-if="!item"
            title="ItemTypes"
            :items="assetTypes"
            @show-item="showItem"
            ref="table"
        >
            <b-row>
                <b-col offset="8" class="text-right">
                    <b-button
                        variant="primary"
                        v-show="hasPermissionCreate"
                        @click="item = {}"
                        >Add Asset Type</b-button
                    >
                </b-col>
            </b-row>
        </list-items>
    </b-container>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import utilityMixins from '@/mixins/utilityMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import ListItems from './ListItems'
import ViewItem from './ViewItem'
import errorHandlingMixins from '@/mixins/errorHandlingMixins'

export default {
    name: 'AssetTypes',
    components: {
        ListItems,
        ViewItem,
    },
    mixins: [
        popupMixins,
        utilityMixins,
        permissionsMixins,
        errorHandlingMixins,
    ],
    data: () => {
        return {
            item: null,
            componentName: 'Asset Type',
        }
    },
    mounted() {
        this.doSearch()
    },
    computed: {
        assetTypes() {
            const types = this.$store.state.assets.types
            console.log('types', types)
            return types
        },
    },

    methods: {
        doSearch() {
            this.$store.dispatch('assets/listTypes')
        },

        showItem(id) {
            const item = this.assetTypes.find(x => x.id === id)
            this.item = { ...item }
        },

        showError(error, name) {
            const interror = 'Internal Server Error'
            if (interror == error.message) {
                this.genericToast(
                    this.componentName,
                    'Duplicate',
                    'danger',
                    `${name} already exists as an ${
                        this.componentName
                    }. Please create a new ${this.componentName.toLowerCase()}`
                )
            }
        },

        alertSuccess(action, name) {
            this.genericToast(
                this.componentName,
                action,
                'success',
                `"${name}" has been successfully ${action.toLowerCase()}`
            )

            this.item = null
            this.doSearch()
        },
    },
}
</script>
<style></style>
